export default {
    title: '{fullName} profile',
    breadcrumbs: 'Member profile',
    labels: {
        short_biography: 'About {fullName}',
        years_in_practice: 'Years in practice',
        board_certified: 'Board certified?',
        gender: 'Gender',
        languages: 'Languages spoken',
        insurance_plans_accepted: 'Insurance plans accepted',
        medical_schools: 'Medical schools',
        affiliated_hospitals: 'Affiliated hospitals',
        residencies: 'Residencies',
        fellowships: 'Fellowships',
        physician_group: 'Provider group',
    },
    preview_profile_link: 'Preview profile',
    tooltip: 'Go to user profile',
}
